import { type ComponentProps, type ComponentPropsWithRef, type ReactNode } from 'react'

import { FloatingHoverCard } from '@/components/common/Floating'
import { LinkRoute } from '@/components/common/Link'
import { type RecType } from '@/defs/rec'
import { useCardModalButton } from '@/hooks/useCardModalButton'

type Props = {
  children: ReactNode
  className?: string
  disableModal?: boolean
  disablePreview?: boolean
  placement?: ComponentProps<typeof FloatingHoverCard>['placement']
  rec: RecType
} & Omit<ComponentPropsWithRef<typeof LinkRoute>, 'href'>

export const CardLink = ({ children, className, disableModal, disablePreview, placement, rec, ...props }: Props) => {
  const { cardLink, onClick } = useCardModalButton({ rec })

  const linkElement = (
    <LinkRoute className={className} href={cardLink} onClick={!disableModal ? onClick : undefined} {...props}>
      {children}
    </LinkRoute>
  )

  if (disablePreview) return linkElement

  return (
    <FloatingHoverCard placement={placement} rec={rec}>
      {linkElement}
    </FloatingHoverCard>
  )
}
